export default function TrustBar() {
  return (
    <section className="bg-[#1a1a1a] border-b border-white/10 py-5 px-6 md:px-10">
      <div className="w-full flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-inter text-white/50 text-xs tracking-widest uppercase text-center md:text-left">
          Trusted by contractors &amp; builders across Las Vegas
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8">
          {/* Google */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-google-fill text-[#C9A84C] text-lg"></i>
            </div>
            <div>
              <div className="font-barlow font-700 text-white text-sm leading-none">Google</div>
              <div className="font-inter text-white/40 text-[10px] tracking-wide">Business Profile</div>
            </div>
          </div>

          <div className="w-px h-6 bg-white/10 hidden md:block"></div>

          {/* Yelp */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-star-line text-[#C9A84C] text-lg"></i>
            </div>
            <div>
              <div className="font-barlow font-700 text-white text-sm leading-none">Yelp</div>
              <div className="font-inter text-white/40 text-[10px] tracking-wide">Listed &amp; Verified</div>
            </div>
          </div>

          <div className="w-px h-6 bg-white/10 hidden md:block"></div>

          {/* BBB */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-shield-check-line text-[#C9A84C] text-lg"></i>
            </div>
            <div>
              <div className="font-barlow font-700 text-white text-sm leading-none">BBB</div>
              <div className="font-inter text-white/40 text-[10px] tracking-wide">Accredited Business</div>
            </div>
          </div>

          <div className="w-px h-6 bg-white/10 hidden md:block"></div>

          {/* Licensed */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-award-line text-[#C9A84C] text-lg"></i>
            </div>
            <div>
              <div className="font-barlow font-700 text-white text-sm leading-none">Licensed</div>
              <div className="font-inter text-white/40 text-[10px] tracking-wide">Nevada LLC</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
